define.alias("ember-composable-helpers/helpers/shuffle", "media/helpers/shuffle");